import { CenteredBox } from "../../components/Styled";
import { Alert, Box, Typography } from "@mui/material";

const NoShares = () => {
  return <CenteredBox>
    <Box display="flex" flexDirection="column" gap="1rem" m="2rem" alignItems="center" maxWidth="600px">
      {/* Mensaje de aviso sobre la base de datos */}
      <Alert 
        severity="warning" 
        sx={{ 
          backgroundColor: '#fff3cd',
          border: '2px solid #ffc107',
          width: '100%',
          '& .MuiAlert-message': {
            fontSize: '1rem',
            fontWeight: 'bold'
          }
        }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
          ATENCIÓN
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Hemos tenido un error en la base de datos y tus mineros y saldo saldrán vacíos.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
        <strong>El Bitcoin minado y los mineros siguen igual y podrás verlos en cuanto te los añadamos.</strong>
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Para restaurar tu saldo y mineros compartidos correctamente, por favor escríbenos por WhatsApp a: 
          <strong> +34 626 10 82 52</strong>
        </Typography>
        <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 1 }}>
          Disculpa las molestias. Estamos trabajando para solucionarlo lo antes posible. Pero por desgracia necesitaremos de su cooperación para hacerlo.
        </Typography>
      </Alert>
      
      <Typography variant="h4" textAlign="center" sx={{ mt: 2 }}>
        Página de Mineros Compartidos
      </Typography>
      <Typography variant="body1" textAlign="center" color="text.secondary">
        Aquí aparecerán tus shares una vez que los restauremos.
      </Typography>
    </Box>
  </CenteredBox>;
};
export default NoShares;
